import React from 'react';
//import { createBrowserHistory } from 'history';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'; //← Bridge React and Redux
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { store } from './store/configureStore';


//let store = configureStore(history);

//startListener(history, store);

//let currentLocation = store.getState().router.pathname;
//let initialRoute = routeComponentFromPath('/');
//store.dispatch(initialRoute.action());

/*let unsubscribe = store.subscribe(() => {
    let previousLocation = currentLocation
    currentLocation = store.getState().router.pathname

    if (previousLocation !== currentLocation) {
        console.log(`Location changed from ${previousLocation} to ${currentLocation}`)
        const routeObject = routeComponentFromPath(currentLocation);
        store.dispatch(routeObject.action());
        //render(routeObject.component);
    }
}); */

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// registerServiceWorker();
